import styled from "styled-components";

const Req = styled.span`

font-size: 12px;
color: black;

display: flex;
align-items: center;
`

export default Req;